/**
 * Copyright (c) 2018 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import React from 'react';
import DelegationLogRow from './delegationlog.row';
import { generateIteratorKey as keygen } from '../../utils/helpers';

class DelegationLogService {
  static groupAssignmentsByHiredOrg(items) {
    return items.reduce((acc, cv) => {
      const { user } = cv;
      const { hiredOrganization } = user;

      const ac = acc[hiredOrganization.hiredOrgGid] || [];
      acc[hiredOrganization.hiredOrgGid] = ac.concat([cv]);
      return acc;
    }, {});
  }

  static createGrid(study, logs, expandAll) {
    const rows = [];

    if (null == logs) {
      return rows;
    }
    const groupData = this.groupAssignmentsByHiredOrg(logs);
    const groupDataKeys = Object.keys(groupData);

    groupDataKeys.forEach((hiredOrgGid, i) => {
      const evKey = expandAll ? '1' : i;
      const row = <DelegationLogRow study={study} models={groupData[hiredOrgGid]} eventKey={evKey} {...keygen()} />;

      rows.push(row);
    });
    return rows;
  }
}

export default DelegationLogService;
